<template>
  <div class="white" style="margin:0">
      <div class="container" style="padding:30px">
        <ul class="collapsible main-pattern hoverable" style="margin:0;">
          <li class="active">
            <div class="collapsible-header"><i class="material-icons">info</i>Present</div>
            <div class="collapsible-body">
              <div class="row valign-wrapper">
                <div class="col s4">
                  <img src="./../assets/profile/Fr.-Mathew-Varghese-263x300.jpg" alt="" class="responsive-img" style=""> <!-- notice the "circle" class -->
                </div>
                <div class="col s8">
                  <h3>Fr. Mathew Varghese</h3>
                  <strong class="black-text">
                    From 2017 to present
                  </strong>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="collapsible-header"><i class="material-icons">info</i>From 2014 to 2017</div>
            <div class="collapsible-body">
              <div class="row valign-wrapper">
                <div class="col s4">
                  <img src="./../assets/profile/Fr.-Sam-V.-Gabriel-Cor-Episcopos-263x300.jpg" alt="" class="responsive-img" style=""> <!-- notice the "circle" class -->
                </div>
                <div class="col s8">
                  <h3>Fr. Sam. V. Gabriel Cor-Episcopos</h3>
                  <strong class="black-text">
                    From 2014 to 2017
                  </strong>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="collapsible-header"><i class="material-icons">info</i>From 2011 to 2014</div>
            <div class="collapsible-body">
              <div class="row valign-wrapper">
                <div class="col s4">
                  <img src="./../assets/profile/fr.-johnson-iype-263x300.jpg" alt="" class="responsive-img" style=""> <!-- notice the "circle" class -->
                </div>
                <div class="col s8">
                  <h3>Fr. Johnson Iype</h3>
                  <strong class="black-text">
                    From 2011 to 2014
                  </strong>
                </div>
              </div>
            </div>
          </li>
        </ul>
    </div>
  </div>
</template>

<script>
function init(){
  var elems = document.querySelectorAll('.collapsible');
  var instances = M.Collapsible.init(elems, {});
}
export default {
  name: "Vicars",
  mounted: init
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Vicars.vue